import { INTRO_SCREEN } from 'constants/screens';

import PropTypes from 'prop-types';
import React, { useReducer } from 'react';

import { AppContext, appReducer } from './app-context';

function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, {
    screen: INTRO_SCREEN,
    progress: 0,
  });

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
}

AppProvider.propTypes = {
  children: PropTypes.node,
};

AppProvider.defaultProps = {
  children: null,
};

export default AppProvider;
